export default __webpack_public_path__ + "static/media/buenos-negocios.d8a9a067.png";